export const NEWSPAPER_PERMIT = 'newspaper-permit';
export const NEWSPAPER_CLASSIFICATIONS = 'newspaper-classifications';
export const PARTICULARS_OF_NEWSPAPER = 'particulars-of-newspaper';
export const PARTICULARS_OF_PRINTER = 'particulars-of-printer';
export const PARTICULARS_OF_PUBLISHER = 'particulars-of-publisher';
export const ADDITIONAL_PARTICULARS_OF_APPLICANT = 'additional-particulars-of-applicant';
export const PARTICULARS_OF_CHIEF_EDITOR = 'particulars-of-chief-editor';
export const SUPPORTING_DOCUMENTS = 'supporting-documents';
import { RuleProps } from 'types/application';

export const NPP_LICENCE = [
    {
        sectionID: NEWSPAPER_PERMIT,
        sectionName: 'Newspaper Permit',
        fieldList: [
            {
                id: 'please-specifiy-the-type-of-permit-to-apply',
                label: 'Please specify the type of Permit to apply',
                type: 'text',
                span: 12
            },
            {
                id: 'mode-of-print',
                label: 'Mode of print',
                type: 'text'
            },
            {
                id: 'location-of-print',
                label: 'Location of Print',
                type: 'text'
            },
            {
                id: 'printing-press-licence-no',
                label: 'Printing Press Licence No',
                type: 'text'
            }
        ]
    },
    {
        sectionID: NEWSPAPER_CLASSIFICATIONS,
        sectionName: 'Newspaper Classifications',
        fieldList: [
            {
                id: 'objectives',
                label: 'Objectives',
                type: 'text',
                span: 12
            },
            {
                id: 'target-readers',
                label: 'Target Readers',
                type: 'text',
                span: 12
            },
            {
                id: 'contents',
                label: 'Contents',
                type: 'text',
                span: 12
            },
            {
                id: 'regular-features',
                label: 'Regular Features',
                type: 'text',
                span: 12
            },
            {
                id: 'genre-code',
                label: 'Genre Code',
                type: 'text'
            },
            {
                id: 'genre-description',
                label: 'Genre Description',
                type: 'text'
            }
        ]
    },
    {
        sectionID: PARTICULARS_OF_NEWSPAPER,
        sectionName: 'Particulars of Newspaper',
        fieldList: [
            {
                id: 'name-of-newspaper-in-english',
                label: 'Name of Newspaper (In English)',
                type: 'text',
                span: 12
            },
            {
                id: 'languages',
                label: 'Language(s)',
                type: 'text'
            },
            {
                id: 'other-languages',
                label: 'Other Language(s)',
                type: 'text',
                rule: {
                    baseIds: [`${PARTICULARS_OF_NEWSPAPER}-other-languages`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_NEWSPAPER}-other-languages`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'frequency',
                label: 'Frequency',
                type: 'text',
                span: 12
            },
            {
                id: 'frequency-description-1',
                label: 'Frequency Description (1)',
                type: 'text',
                rule: {
                    baseIds: [`${PARTICULARS_OF_NEWSPAPER}-frequency-description-1`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_NEWSPAPER}-frequency`] !== 'Others');
                        return result;
                    }
                }
            },
            {
                id: 'frequency-description-2',
                label: 'Frequency Description (2)',
                type: 'text',
                rule: {
                    baseIds: [`${PARTICULARS_OF_NEWSPAPER}-frequency-description-2`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_NEWSPAPER}-frequency`] !== 'Others');
                        return result;
                    }
                }
            },
            {
                id: 'reason-for-exemption',
                label: 'Reason for Exemption',
                type: 'text',
                span: 12
            },
            {
                id: 'free-copy',
                label: 'Free Copy',
                type: 'text'
            },
            {
                id: 'selling-price',
                label: 'If No, selling price $',
                type: 'text'
            },
            {
                id: 'total-no-of-copies-printed-per-issue',
                label: 'Total No. of Copies printed per issue',
                type: 'text'
            },
            {
                id: 'no-of-copies-to-be-circulated-in-singapore-printed-per-issue',
                label: 'No. of copies to be circulated in Singapore printed per issue',
                type: 'text'
            },
            {
                id: 'advertisements',
                label: 'Advertisements',
                type: 'text'
            },
            {
                id: 'online-link',
                label: 'If this newspapers, is available online, state the URL(http://) ',
                type: 'text'
            }
        ]
    },
    {
        sectionID: PARTICULARS_OF_PRINTER,
        sectionName: 'Particulars of Printer',
        rule: {
            baseIds: [`${PARTICULARS_OF_PRINTER}-type-of-printer`],
            hidden: ({ baseValues }: RuleProps) => {
                const result = Boolean(baseValues && baseValues[`${NEWSPAPER_PERMIT}-mode-of-print`] === 'In-House');
                return result;
            }
        },
        fieldList: [
            {
                id: 'type-of-printer',
                label: 'Type of Printer',
                type: 'text'
            },
            {
                id: 'name-of-printing-press-foreign',
                label: 'Name of Printing Press (Foreign)',
                type: 'text',
                rule: {
                    baseIds: [`${PARTICULARS_OF_PRINTER}-name-of-printing-press`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_PRINTER}-type-of-printer`] === 'Local');
                        return result;
                    }
                }
            },
            {
                id: 'name-of-printing-press',
                label: 'Name of Printing Press',
                type: 'text',
                rule: {
                    baseIds: [`${PARTICULARS_OF_PRINTER}-name-of-printing-press-foreign`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_PRINTER}-type-of-printer`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'printing-press-licence-no',
                label: 'Printing Press Licence No',
                type: 'text',
                rule: {
                    baseIds: [`${PARTICULARS_OF_PRINTER}-printing-press-licence-no`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_PRINTER}-type-of-printer`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'company-id',
                label: 'Company ID',
                type: 'text',
                rule: {
                    baseIds: [`${PARTICULARS_OF_PRINTER}-company-id`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_PRINTER}-type-of-printer`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'address-type',
                mainLabel: 'Address',
                label: 'Address Type',
                type: 'text'
            },
            {
                id: 'address-line-one',
                label: 'Address Line 1',
                type: 'text',
                rule: {
                    baseIds: [`${PARTICULARS_OF_PRINTER}-address-line-one`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_PRINTER}-address-type`] === 'Local');
                        return result;
                    }
                }
            },
            {
                id: 'address-line-two',
                label: 'Address Line 2',
                type: 'text',
                rule: {
                    baseIds: [`${PARTICULARS_OF_PRINTER}-address-line-two`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_PRINTER}-address-type`] === 'Local');
                        return result;
                    }
                }
            },
            {
                id: 'address-line-three',
                label: 'Address Line 3',
                type: 'text',
                rule: {
                    baseIds: [`${PARTICULARS_OF_PRINTER}-address-line-three`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_PRINTER}-address-type`] === 'Local');
                        return result;
                    }
                }
            },
            {
                id: 'country',
                label: 'Country',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${PARTICULARS_OF_PRINTER}-country`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_PRINTER}-address-type`] === 'Local');
                        return result;
                    }
                }
            },
            {
                id: 'postal-code',
                label: 'Postal Code',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${PARTICULARS_OF_PRINTER}-postal-code`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_PRINTER}-address-type`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'block-house-no',
                label: 'Block/House No.',
                type: 'text',
                rule: {
                    baseIds: [`${PARTICULARS_OF_PRINTER}-block-house-no`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_PRINTER}-address-type`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'street-name',
                label: 'Street Name',
                type: 'text',
                rule: {
                    baseIds: [`${PARTICULARS_OF_PRINTER}-street-name`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_PRINTER}-address-type`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'floor-level-optional',
                label: 'Floor/Level (Optional)',
                type: 'text',
                rule: {
                    baseIds: [`${PARTICULARS_OF_PRINTER}-floor-level-optional`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_PRINTER}-address-type`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'unit-optional',
                label: 'Unit (Optional)',
                type: 'text',
                rule: {
                    baseIds: [`${PARTICULARS_OF_PRINTER}-unit-optional`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_PRINTER}-address-type`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'building-name',
                label: 'Building Name',
                type: 'text',
                rule: {
                    baseIds: [`${PARTICULARS_OF_PRINTER}-building-name`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_PRINTER}-address-type`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'tel-no',
                mainLabel: 'Contact Info',
                label: 'Tel No',
                type: 'text',
                span: 6
            },
            {
                id: 'mobile-no',
                label: 'Mobile No',
                type: 'text',
                span: 6
            },
            {
                id: 'email',
                label: 'Email',
                type: 'text',
                span: 6
            }
        ]
    },
    {
        sectionID: PARTICULARS_OF_PUBLISHER,
        sectionName: 'Particulars of Publisher',
        fieldList: [
            {
                id: 'type-of-publisher',
                label: 'Type of Publisher',
                type: 'text'
            },
            {
                id: 'name-of-publisher-company-name',
                label: 'Name of Publisher/Company Name',
                type: 'text'
            },
            {
                id: 'address-type',
                mainLabel: 'Address',
                secondaryMainLabel: 'Local Address',
                label: 'Address Type',
                type: 'text',
                span: 12
            },
            {
                id: 'address-line-one',
                label: 'Address Line 1',
                type: 'text',
                rule: {
                    baseIds: [`${PARTICULARS_OF_PUBLISHER}-address-line-one`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_PUBLISHER}-address-type`] === 'Local');
                        return result;
                    }
                }
            },
            {
                id: 'address-line-two',
                label: 'Address Line 2',
                type: 'text',
                rule: {
                    baseIds: [`${PARTICULARS_OF_PUBLISHER}-address-line-two`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_PUBLISHER}-address-type`] === 'Local');
                        return result;
                    }
                }
            },
            {
                id: 'address-line-three',
                label: 'Address Line 3',
                type: 'text',
                rule: {
                    baseIds: [`${PARTICULARS_OF_PUBLISHER}-address-line-three`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_PUBLISHER}-address-type`] === 'Local');
                        return result;
                    }
                }
            },
            {
                id: 'country',
                label: 'Country',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${PARTICULARS_OF_PUBLISHER}-country`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_PUBLISHER}-address-type`] === 'Local');
                        return result;
                    }
                }
            },
            {
                id: 'postal-code',
                label: 'Postal Code',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${PARTICULARS_OF_PUBLISHER}-postal-code`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_PUBLISHER}-address-type`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'block-house-no',
                label: 'Block/House No.',
                type: 'text',
                rule: {
                    baseIds: [`${PARTICULARS_OF_PUBLISHER}-block-house-no`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_PUBLISHER}-address-type`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'street-name',
                label: 'Street Name',
                type: 'text',
                rule: {
                    baseIds: [`${PARTICULARS_OF_PUBLISHER}-street-name`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_PUBLISHER}-address-type`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'floor-level-optional',
                label: 'Floor/Level (Optional)',
                type: 'text',
                rule: {
                    baseIds: [`${PARTICULARS_OF_PUBLISHER}-floor-level-optional`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_PUBLISHER}-address-type`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'unit-optional',
                label: 'Unit (Optional)',
                type: 'text',
                rule: {
                    baseIds: [`${PARTICULARS_OF_PUBLISHER}-unit-optional`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_PUBLISHER}-address-type`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'building-name',
                label: 'Building Name',
                type: 'text',
                rule: {
                    baseIds: [`${PARTICULARS_OF_PUBLISHER}-building-name`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_PUBLISHER}-address-type`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'do-you-have-local-or-foreign-contact-number',
                mainLabel: 'Office Contact',
                label: 'Do You have Local or Foreign Contact Number?',
                type: 'text',
                span: 12
            },
            {
                id: 'tel-no',
                label: 'Tel No',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${PARTICULARS_OF_PUBLISHER}-tel-no`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            (baseValues &&
                                baseValues[`${PARTICULARS_OF_PUBLISHER}-do-you-have-local-or-foreign-contact-number`] === 'Foreign') ||
                                (baseValues &&
                                    baseValues[`${PARTICULARS_OF_PUBLISHER}-do-you-have-local-or-foreign-contact-number`] === '-')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'mobile-no',
                label: 'Mobile No',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${PARTICULARS_OF_PUBLISHER}-mobile-no`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            (baseValues &&
                                baseValues[`${PARTICULARS_OF_PUBLISHER}-do-you-have-local-or-foreign-contact-number`] === 'Foreign') ||
                                (baseValues &&
                                    baseValues[`${PARTICULARS_OF_PUBLISHER}-do-you-have-local-or-foreign-contact-number`] === '-')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'overseas-tel-no',
                label: 'Overseas Tel No',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${PARTICULARS_OF_PUBLISHER}-overseas-tel-no`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            (baseValues &&
                                baseValues[`${PARTICULARS_OF_PUBLISHER}-do-you-have-local-or-foreign-contact-number`] === 'Local') ||
                                (baseValues &&
                                    baseValues[`${PARTICULARS_OF_PUBLISHER}-do-you-have-local-or-foreign-contact-number`] === '-')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'overseas-mobile-no',
                label: 'Overseas Mobile No',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${PARTICULARS_OF_PUBLISHER}-overseas-mobile-no`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            (baseValues &&
                                baseValues[`${PARTICULARS_OF_PUBLISHER}-do-you-have-local-or-foreign-contact-number`] === 'Local') ||
                                (baseValues &&
                                    baseValues[`${PARTICULARS_OF_PUBLISHER}-do-you-have-local-or-foreign-contact-number`] === '-')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'email',
                label: 'Email',
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: ADDITIONAL_PARTICULARS_OF_APPLICANT,
        sectionName: 'Additional Particulars of Applicant (Chief Editor/Proprietor)',
        fieldList: [
            {
                id: 'designation',
                label: 'Designation',
                type: 'text',
                span: 12
            },
            {
                id: 'is-the-applicants-company-same-as-the-publisher',
                mainLabel: 'Particulars of Applicant (Chief Editor/Proprietor)',
                label: 'Is the Applicant’s Company same as the Publisher?',
                type: 'text',
                span: 12
            },
            {
                id: 'name-of-registered-office-company-employer',
                mainLabel: 'Details of Registered Office/ Company/ Employer',
                label: 'Name of Registered Office/ Company/ Employer',
                type: 'text'
            },
            {
                id: 'uen-registration-number',
                label: 'UEN/Registration Number',
                type: 'text'
            },
            {
                id: 'uen-registration-number-type',
                label: 'UEN/Registration Number Type',
                type: 'text',
                rule: {
                    baseIds: [
                        `${ADDITIONAL_PARTICULARS_OF_APPLICANT}-is-the-chief-editor-same-as-applicant`,
                        `${PARTICULARS_OF_CHIEF_EDITOR}-uen-registration-number-type`,
                        `${PARTICULARS_OF_CHIEF_EDITOR}-is-the-chief-editors-company-same-as-publisher`
                    ],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            (baseValues && baseValues[`${PARTICULARS_OF_CHIEF_EDITOR}-uen-registration-number-type`] === '-') ||
                                !(
                                    baseValues &&
                                    baseValues[`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-is-the-chief-editor-same-as-applicant`] === 'No' &&
                                    baseValues &&
                                    baseValues[`${PARTICULARS_OF_CHIEF_EDITOR}-is-the-chief-editors-company-same-as-publisher`] === 'No'
                                )
                        );
                        return result;
                    }
                }
            },
            {
                id: 'address-type',
                mainLabel: 'Office Address',
                label: 'Address Type',
                type: 'text',
                span: 12
            },
            {
                id: 'address-line-one',
                label: 'Address Line 1',
                type: 'text',
                rule: {
                    baseIds: [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-address-line-one`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-address-type`] === 'Local');
                        return result;
                    }
                }
            },
            {
                id: 'address-line-two',
                label: 'Address Line 2',
                type: 'text',
                rule: {
                    baseIds: [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-address-line-two`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-address-type`] === 'Local');
                        return result;
                    }
                }
            },
            {
                id: 'address-line-three',
                label: 'Address Line 3',
                type: 'text',
                rule: {
                    baseIds: [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-address-line-three`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-address-type`] === 'Local');
                        return result;
                    }
                }
            },
            {
                id: 'country',
                label: 'Country',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-country`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-address-type`] === 'Local');
                        return result;
                    }
                }
            },
            {
                id: 'postal-code',
                label: 'Postal Code',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-postal-code`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues && baseValues[`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-address-type`] === 'Foreign'
                        );
                        return result;
                    }
                }
            },
            {
                id: 'block-house-no',
                label: 'Block/House No.',
                type: 'text',
                rule: {
                    baseIds: [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-block-house-no`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues && baseValues[`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-address-type`] === 'Foreign'
                        );
                        return result;
                    }
                }
            },
            {
                id: 'street-name',
                label: 'Street Name',
                type: 'text',
                rule: {
                    baseIds: [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-street-name`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues && baseValues[`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-address-type`] === 'Foreign'
                        );
                        return result;
                    }
                }
            },
            {
                id: 'floor-level-optional',
                label: 'Floor/Level (Optional)',
                type: 'text',
                rule: {
                    baseIds: [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-floor-level-optional`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues && baseValues[`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-address-type`] === 'Foreign'
                        );
                        return result;
                    }
                }
            },
            {
                id: 'unit-optional',
                label: 'Unit (Optional)',
                type: 'text',
                rule: {
                    baseIds: [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-unit-optional`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues && baseValues[`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-address-type`] === 'Foreign'
                        );
                        return result;
                    }
                }
            },
            {
                id: 'building-name',
                label: 'Building Name',
                type: 'text',
                rule: {
                    baseIds: [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-building-name`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues && baseValues[`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-address-type`] === 'Foreign'
                        );
                        return result;
                    }
                }
            },
            {
                id: 'do-you-have-local-or-foreign-contact-number',
                mainLabel: 'Office Contact',
                label: 'Do You have Local or Foreign Contact Number?',
                type: 'text',
                span: 12
            },
            {
                id: 'tel-no',
                label: 'Tel No',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-tel-no`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            (baseValues &&
                                baseValues[`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-do-you-have-local-or-foreign-contact-number`] ===
                                    'Foreign') ||
                                (baseValues &&
                                    baseValues[`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-do-you-have-local-or-foreign-contact-number`] ===
                                        '-')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'mobile-no',
                label: 'Mobile No',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-mobile-no`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            (baseValues &&
                                baseValues[`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-do-you-have-local-or-foreign-contact-number`] ===
                                    'Foreign') ||
                                (baseValues &&
                                    baseValues[`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-do-you-have-local-or-foreign-contact-number`] ===
                                        '-')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'overseas-tel-no',
                label: 'Overseas Tel No',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-overseas-tel-no`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            (baseValues &&
                                baseValues[`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-do-you-have-local-or-foreign-contact-number`] ===
                                    'Local') ||
                                (baseValues &&
                                    baseValues[`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-do-you-have-local-or-foreign-contact-number`] ===
                                        '-')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'overseas-mobile-no',
                label: 'Overseas Mobile No',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-overseas-mobile-no`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            (baseValues &&
                                baseValues[`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-do-you-have-local-or-foreign-contact-number`] ===
                                    'Local') ||
                                (baseValues &&
                                    baseValues[`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-do-you-have-local-or-foreign-contact-number`] ===
                                        '-')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'email',
                label: 'Email',
                type: 'text',
                span: 12
            },
            {
                id: 'is-the-chief-editor-same-as-applicant',
                label: 'Is the Chief Editor same as applicant?',
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: PARTICULARS_OF_CHIEF_EDITOR,
        sectionName: 'Particulars of Chief Editor',
        fieldList: [
            {
                id: 'salutation-title',
                label: 'Salutation/Title',
                type: 'text'
            },
            {
                id: 'names-as-per-official-document',
                label: 'Names (as per official document)',
                type: 'text'
            },
            // {
            //     id: 'passport-number',
            //     label: 'Passport No.',
            //     type: 'text'
            // },
            // {
            //     id: 'date-of-birth',
            //     label: 'Date of Birth',
            //     type: 'text'
            // },
            {
                id: 'designation',
                label: 'Designation',
                type: 'text'
            },
            {
                id: 'is-the-chief-editors-company-same-as-publisher',
                label: 'Is the Chief Editor’s company same as Publisher',
                type: 'text',
                rule: {
                    baseIds: [`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-is-the-chief-editor-same-as-applicant`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                baseValues[`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-is-the-chief-editor-same-as-applicant`] === 'Yes'
                        );
                        return result;
                    }
                }
            },
            {
                id: 'name-of-registered-office-company-employer',
                mainLabel: 'Details of Registered Office/ Company/ Employer',
                label: 'Name of Registered Office/ Company/ Employer',
                type: 'text'
            },
            {
                id: 'uen-registration-number',
                label: 'UEN/Registration Number',
                type: 'text'
            },
            {
                id: 'uen-registration-number-type',
                label: 'UEN/Registration Number Type',
                type: 'text',
                rule: {
                    baseIds: [
                        `${ADDITIONAL_PARTICULARS_OF_APPLICANT}-is-the-chief-editor-same-as-applicant`,
                        `${PARTICULARS_OF_CHIEF_EDITOR}-uen-registration-number-type`,
                        `${PARTICULARS_OF_CHIEF_EDITOR}-is-the-chief-editors-company-same-as-publisher`
                    ],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            (baseValues && baseValues[`${PARTICULARS_OF_CHIEF_EDITOR}-uen-registration-number-type`] === '-') ||
                                !(
                                    baseValues &&
                                    baseValues[`${ADDITIONAL_PARTICULARS_OF_APPLICANT}-is-the-chief-editor-same-as-applicant`] === 'No' &&
                                    baseValues &&
                                    baseValues[`${PARTICULARS_OF_CHIEF_EDITOR}-is-the-chief-editors-company-same-as-publisher`] === 'No'
                                )
                        );
                        return result;
                    }
                }
            },
            {
                id: 'address-type',
                mainLabel: 'Office Address',
                label: 'Address Type',
                type: 'text',
                span: 12
            },
            {
                id: 'address-line-one',
                label: 'Address Line 1',
                type: 'text',
                rule: {
                    baseIds: [`${PARTICULARS_OF_CHIEF_EDITOR}-address-line-one`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_CHIEF_EDITOR}-address-type`] === 'Local');
                        return result;
                    }
                }
            },
            {
                id: 'address-line-two',
                label: 'Address Line 2',
                type: 'text',
                rule: {
                    baseIds: [`${PARTICULARS_OF_CHIEF_EDITOR}-address-line-two`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_CHIEF_EDITOR}-address-type`] === 'Local');
                        return result;
                    }
                }
            },
            {
                id: 'address-line-three',
                label: 'Address Line 3',
                type: 'text',
                rule: {
                    baseIds: [`${PARTICULARS_OF_CHIEF_EDITOR}-address-line-three`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_CHIEF_EDITOR}-address-type`] === 'Local');
                        return result;
                    }
                }
            },
            {
                id: 'country',
                label: 'Country',
                type: 'text',
                rule: {
                    baseIds: [`${PARTICULARS_OF_CHIEF_EDITOR}-country`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_CHIEF_EDITOR}-address-type`] === 'Local');
                        return result;
                    }
                }
            },
            {
                id: 'postal-code',
                label: 'Postal Code',
                type: 'text',
                rule: {
                    baseIds: [`${PARTICULARS_OF_CHIEF_EDITOR}-postal-code`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_CHIEF_EDITOR}-address-type`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'block-house-no',
                label: 'Block/House No.',
                type: 'text',
                rule: {
                    baseIds: [`${PARTICULARS_OF_CHIEF_EDITOR}-block-house-no`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_CHIEF_EDITOR}-address-type`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'street-name',
                label: 'Street Name',
                type: 'text',
                rule: {
                    baseIds: [`${PARTICULARS_OF_CHIEF_EDITOR}-street-name`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_CHIEF_EDITOR}-address-type`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'floor-level-optional',
                label: 'Floor/Level (Optional)',
                type: 'text',
                rule: {
                    baseIds: [`${PARTICULARS_OF_CHIEF_EDITOR}-floor-level-optional`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_CHIEF_EDITOR}-address-type`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'unit-optional',
                label: 'Unit (Optional)',
                type: 'text',
                rule: {
                    baseIds: [`${PARTICULARS_OF_CHIEF_EDITOR}-unit-optional`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_CHIEF_EDITOR}-address-type`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'building-name',
                label: 'Building Name',
                type: 'text',
                rule: {
                    baseIds: [`${PARTICULARS_OF_CHIEF_EDITOR}-building-name`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PARTICULARS_OF_CHIEF_EDITOR}-address-type`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'do-you-have-local-or-foreign-contact-number',
                mainLabel: 'Office Contact',
                label: 'Do You have Local or Foreign Contact Number?',
                type: 'text',
                span: 12
            },
            {
                id: 'tel-no',
                label: 'Tel No',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${PARTICULARS_OF_CHIEF_EDITOR}-tel-no`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            (baseValues &&
                                baseValues[`${PARTICULARS_OF_CHIEF_EDITOR}-do-you-have-local-or-foreign-contact-number`] === 'Foreign') ||
                                (baseValues &&
                                    baseValues[`${PARTICULARS_OF_CHIEF_EDITOR}-do-you-have-local-or-foreign-contact-number`] === '-')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'mobile-no',
                label: 'Mobile No',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${PARTICULARS_OF_CHIEF_EDITOR}-mobile-no`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            (baseValues &&
                                baseValues[`${PARTICULARS_OF_CHIEF_EDITOR}-do-you-have-local-or-foreign-contact-number`] === 'Foreign') ||
                                (baseValues &&
                                    baseValues[`${PARTICULARS_OF_CHIEF_EDITOR}-do-you-have-local-or-foreign-contact-number`] === '-')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'overseas-tel-no',
                label: 'Overseas Tel No',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${PARTICULARS_OF_CHIEF_EDITOR}-overseas-tel-no`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            (baseValues &&
                                baseValues[`${PARTICULARS_OF_CHIEF_EDITOR}-do-you-have-local-or-foreign-contact-number`] === 'Local') ||
                                (baseValues &&
                                    baseValues[`${PARTICULARS_OF_CHIEF_EDITOR}-do-you-have-local-or-foreign-contact-number`] === '-')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'overseas-mobile-no',
                label: 'Overseas Mobile No',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${PARTICULARS_OF_CHIEF_EDITOR}-overseas-mobile-no`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            (baseValues &&
                                baseValues[`${PARTICULARS_OF_CHIEF_EDITOR}-do-you-have-local-or-foreign-contact-number`] === 'Local') ||
                                (baseValues &&
                                    baseValues[`${PARTICULARS_OF_CHIEF_EDITOR}-do-you-have-local-or-foreign-contact-number`] === '-')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'email',
                label: 'Email',
                type: 'text',
                span: 12
            }
        ]
    }
    // {
    //     sectionID: SUPPORTING_DOCUMENTS,
    //     sectionName: 'Supporting Documents',
    //     rule: {
    //         hidden: true,
    //     },
    //     fieldList: [
    //         {
    //             id: 'supporting-documents',
    //             label: ' ',
    //             type: 'file',
    //             span: 12
    //         }
    //     ]
    // }
];
